import { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

// A legend entry that shows or hides its line, like Chart.js's own legend.
export function LegendToggle({ hidden, onToggle, swatchClassName = '', swatchStyle, children }) {
  return (
    <button type="button" className={`sdkp-legend-toggle ${hidden ? 'sdkp-legend-off' : ''}`} aria-pressed={!hidden} onClick={onToggle}>
      <span className={`sdkp-swatch ${swatchClassName}`} style={swatchStyle} />
      {children}
    </button>
  );
}

export function useHiddenSet() {
  const [hidden, setHidden] = useState(() => new Set());
  const toggle = (key) => setHidden((previous) => {
    const next = new Set(previous);
    if (next.has(key)) next.delete(key);
    else next.add(key);
    return next;
  });
  return [hidden, toggle];
}

export const TREND_COLORS = {
  cost: '#2563eb', worse: '#b91c1c', better: '#15803d', band: 'rgba(37, 99, 235, 0.12)', raw: '#94a3b8',
};

// Draws a dashed vertical line, labelled with the version, where a run first
// used a new SDK version.
export const sdkVersionMarkers = {
  id: 'sdkVersionMarkers',
  afterDatasetsDraw(chart, args, options) {
    const markers = options?.markers || [];
    const xScale = chart.scales?.x;
    if (!markers.length || !xScale) return;
    const { ctx, chartArea } = chart;
    ctx.save();
    ctx.setLineDash([3, 3]);
    ctx.strokeStyle = '#6b7280';
    ctx.fillStyle = '#374151';
    ctx.font = '11px sans-serif';
    // Labels too close to the previous one drop to the next row.
    const rowEnds = [];
    markers.forEach(({ index, label }) => {
      const x = xScale.getPixelForValue(index);
      ctx.beginPath();
      ctx.moveTo(x, chartArea.top);
      ctx.lineTo(x, chartArea.bottom);
      ctx.stroke();
      const width = ctx.measureText(label).width + 8;
      let row = rowEnds.findIndex((end) => end <= x);
      if (row === -1) row = rowEnds.length;
      rowEnds[row] = x + width;
      ctx.fillText(label, x + 4, chartArea.top + 10 + row * 13);
    });
    ctx.restore();
  },
};

export function versionMarkers(versions) {
  let previous = null;
  return versions.reduce((markers, version, index) => {
    if (!version) return markers;
    if (version !== previous) markers.push({ index, label: `SDK ${version}` });
    previous = version;
    return markers;
  }, []);
}
